<template>
  <div id="delay-data-page">
    <b-card no-body class="h-100">
      <!-- header component -->
      <b-card-header>
        <!-- title -->
        <b-card-title class="d-flex align-items-center">
          <i class="bi bi-clock-history"></i>
          <span style="margin-left: 5px"> Delay Data </span>
        </b-card-title>
        <!-- filter component -->
        <div
          class="d-flex flex-wrap gap-5px justify-content-end align-items-center"
        >
          <!-- date filter -->
          <dateRangePicker
            :from_date="filter_data.from_date"
            :to_date="filter_data.to_date"
            @update-value="dateFilterChanged"
          />
          <!-- selisih filter -->
          <div>
            <select
              v-model="filter_data.hour"
              class="form-control"
              @change="getData()"
            >
              <option value="24">1 Hari</option>
              <option value="48">2 Hari</option>
              <option value="72">3 Hari</option>
              <option value="120">5 Hari</option>
              <option value="168">7 Hari</option>
            </select>
          </div>
          <!-- keyword component -->
          <b-input-group class="input-group-merge" style="width: 20rem">
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input
              v-model="filter_data.key"
              placeholder="Masukkan kata kunci..."
            />
          </b-input-group>
        </div>
      </b-card-header>
      <div>
        <!-- loader component -->
        <loader v-if="is_loading" />
        <!-- dataTable -->
        <dataTable
          v-else
          :data="table_data"
          :is_row_clicked="true"
          :is_pagination="false"
          :viewDetail="viewDetail"
        />
        <paginationInfo
          :page="pagination.page"
          :items="pagination.items"
          :count="pagination.count"
          @update-value="paginationChanged"
        />
      </div>
    </b-card>
  </div>
</template>
<script>
import axios from "axios";
import useJwt from "@/auth/jwt/useJwt";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardSubTitle,
  BCardBody,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
} from "bootstrap-vue";
import dataTable from "@/views/components/dataTable.vue";
import loader from "@/views/components/loader.vue";
import paginationInfo from "@/views/components/paginationInfo.vue";
import moment from "moment";
import dateRangePicker from "@/views/components/dateRangePicker.vue";

export default {
  name: "DelayData",
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BCardSubTitle,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    paginationInfo,
    dataTable,
    loader,
    dateRangePicker,
  },
  data() {
    return {
      is_loading: true,
      filter_data: {
        from_date:
          this.$route?.query?.from_date ||
          moment(new Date())
            .subtract(3, "days")
            .format("YYYY-MM-DD 00:00:00"),
        to_date:
          this.$route?.query?.to_date ||
          moment(new Date()).format("YYYY-MM-DD 23:59:59"),
        key: "",
        hour: "24",
      },
      pagination: {
        page: 1,
        items: 10,
        count: 0,
      },
      table_data: {
        fields: [
          {
            key: "no",
            label: "no",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: { width: "1rem" },
          },
          {
            key: "portal_name",
            label: "nama portal",
            sortable: true,
            thClass: "text-left",
            tdClass: "text-left",
          },
          {
            key: "total",
            label: "jumlah berita",
            sortable: true,
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: { width: "20rem" },
          },
        ],
        items: [],
      },
      cancel_token: null,
    };
  },
  created() {
    this.getData();
  },
  watch: {
    "filter_data.key"() {
      if (
        this.filter_data.key.trim().length >= 2 ||
        this.filter_data.key.trim().length == 0
      ) {
        this.getData();
      }
    },
  },
  methods: {
    dateFilterChanged(data) {
      this.filter_data.from_date = data.from_date;
      this.filter_data.to_date = data.to_date;
      this.getData();
    },
    paginationChanged(data) {
      this.pagination = data;
      this.getData();
    },
    getData() {
      this.is_loading = true;
      if (this.cancel_token) {
        this.cancel_token.cancel("ERR_CANCELED");
      }
      this.cancel_token = axios.CancelToken.source();

      let params = {
        ...(this.filter_data.key ? { name: this.filter_data.key } : {}),
        ...(this.filter_data.hour ? { hour: this.filter_data.hour } : {}),
        from_date: this.filter_data.from_date,
        to_date: this.filter_data.to_date,
        page: this.pagination.page,
        items: this.pagination.items,
      };
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api =
        process.env.VUE_APP_API_URL + "stream/data/timestamp?" + query;

      useJwt.axiosIns
        .get(api, { cancelToken: this.cancel_token.token })
        .then((res) => {
          this.cancel_token.value = null;
          this.table_data.items = (res.data?.data || []).map((item) => ({
            ...item,
            _id: item.portal_name,
          }));
          this.pagination.count = res.data?.pagination_info?.total || 0;
        })
        .catch((err) => {
          if (err.message != "ERR_CANCELED") {
            this.cancel_token.value = null;
          } else {
            this.cancel_token.value = "CANCELED";
          }
        })
        .finally(() => {
          if (!this.cancel_token.value) {
            this.is_loading = false;
          }
        }); 
    },
    viewDetail(id) {
      this.$router.push({
        name: "delay-data-detail",
        query: { portal_name: id, hour: this.filter_data.hour, from_date: this.filter_data.from_date, to_date: this.filter_data.to_date },
      });
    },
  },
};
</script>
